import { IconCheck2 } from '@belong/icons';
import { Text } from '@belong/ui';
import { HOMEOWNERS_STRINGS as STRINGS } from '../../../../homeowners.strings';
import css from './gttl-photo-wall.module.css';

const webmVideoSrc =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/gttl/lp_gtr_video_frame.webm';
const mp4VideoSrc =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/gttl/lp_gtr_video_frame.mp4';

export function GttlPhotoWall() {
  return (
    <div className="py-5xl container mx-auto overflow-hidden">
      <div className="gap-xl lg:gap-lg flex flex-col items-center lg:flex-row">
        <div className="flex-1">
          <div className={css.videoContainer}>
            <video
              width="100%"
              height="100%"
              autoPlay
              controls={false}
              muted={true}
              loop={false}
              className={css.video}
              {...{
                playsInline: true,
                'webkit-playsinline': 1,
                'x5-playsinline': 1,
              }}
            >
              <source src={webmVideoSrc} type="video/webm" />
              <source src={mp4VideoSrc} type="video/mp4" />
              Sorry, your browser does not support embedded videos.
            </video>
          </div>
        </div>
        <div className="w-full flex-1">
          {STRINGS['guaranteedTimeToLoveLanding.photoWallStrings'].map(
            (text, key) => (
              <div
                className="mb-xl gap-sm flex items-start last:mb-0"
                key={key}
              >
                <IconCheck2 className="mt-xs" width={22} />
                <Text
                  as="h3"
                  fontWeight="semibold"
                  variant="h3"
                  className="w-full whitespace-pre-line md:whitespace-normal"
                >
                  {text}
                </Text>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
}
